import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";
import { aboutRoutes } from "./routes";
import { IContactsInfoResponse } from "./type";

export const fetchContactsInfo = createAsyncThunk<IContactsInfoResponse[]>(
  "about/fetchContactsInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(aboutRoutes.CONTACTS_INFO);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);